import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptEventDefinitionsAPI from '../../api/wgpt/eventDefinitions';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getEventDefinitions($state) {
    return $state.records;
  },
  getEventDefinition: $state => id => {
    return $state.records.find(r => r.id === Number(id)) || {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptEventDefinitionsAPI.get();
      commit(types.SET_WGPT_EVENT_DEFINITIONS, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await WgptEventDefinitionsAPI.show(id);
      commit(types.ADD_WGPT_EVENT_DEFINITION, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },

  create: async ({ commit }, obj) => {
    commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptEventDefinitionsAPI.create(obj);
      commit(types.ADD_WGPT_EVENT_DEFINITION, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isUpdating: true });
    try {
      const response = await WgptEventDefinitionsAPI.update(id, updateObj);
      commit(types.EDIT_WGPT_EVENT_DEFINITION, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isDeleting: true });
    try {
      await WgptEventDefinitionsAPI.delete(id);
      commit(types.DELETE_WGPT_EVENT_DEFINITION, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_DEFINITION_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_EVENT_DEFINITION_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_EVENT_DEFINITIONS]: MutationHelpers.set,
  [types.ADD_WGPT_EVENT_DEFINITION]: MutationHelpers.setSingleRecord,
  [types.EDIT_WGPT_EVENT_DEFINITION]: MutationHelpers.update,
  [types.DELETE_WGPT_EVENT_DEFINITION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
